export default "__VITE_ASSET__zaHdmJKR__"